import axios from "axios";

//<====HARDCODED====>
import { BOOLVALUE } from "utils/options/BOOLVALUE";
import { AGREEMENT_OPTIONS } from "utils/options/AGREEMENT_OPTIONS";
import { FILECATEGORY } from "utils/options/FILECATEGORY";
import { COUNTRYCODE } from "utils/options/COUNTRYCODE";
import { LANGUAGECODE } from "utils/options/LANGUAGECODE";
import { CURRENCYCODE } from "utils/options/CURRENCYCODE";
import { USERTYPE } from "utils/options/USERTYPE";
import { DEFAULT_SERVICE } from "utils/options/DEFAULT_SERVICE";
import { DEFAULT_SEARCH_FIELD_KEYS } from "utils/accountSearchFields";

//<=================>
const baseURL = `${process.env.REACT_APP_SWESUM_BASEURL}`;

// <===============  SWESUM AUTHENTICATION   =============>
export async function authenticate(username, password) {
  const config = {
    method: "post",
    url: `${baseURL}/identity/login`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      Username: username,
      Password: password,
    }),
  };
  const res = await axios(config);

  return res;
}

// <===============  SWESUM API   =============>
const SwesumClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization:
      window.localStorage.getItem("authData") != "undefined" &&
      window.localStorage.getItem("authData") !== null
        ? JSON.parse(window.localStorage.getItem("authData")).accessToken
        : "",
  },
});

SwesumClient.interceptors.request.use((config) => {
  config.headers["Authorization"] =
    window.localStorage.getItem("authData") !== "undefined" &&
    window.localStorage.getItem("authData") !== null
      ? JSON.parse(window.localStorage.getItem("authData")).accessToken
      : "";
  return config;
});

SwesumClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
      window.localStorage.removeItem("authData");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// No Content-type to allow file-upload
const SwesumFileClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization:
      window.localStorage.getItem("authData") !== "undefined" &&
      window.localStorage.getItem("authData") !== null
        ? JSON.parse(window.localStorage.getItem("authData")).accessToken
        : "",
  },
});

SwesumFileClient.interceptors.request.use((config) => {
  config.headers["Authorization"] =
    window.localStorage.getItem("authData") !== "undefined" &&
    window.localStorage.getItem("authData") !== null
      ? JSON.parse(window.localStorage.getItem("authData")).accessToken
      : "";
  return config;
});

export const SwesumAPI = () => {
  return SwesumClient;
};
//<============= HARDCODED VALUES==============>
export async function getBoolOptionsHC() {
  // const res = await SwesumClient.get(`/option?category=boolvalue`);
  const res = BOOLVALUE;
  return res;
}
export async function getAgreementOptionsHC() {
  //const res = await SwesumClient.get(`/option?category=agreement`);
  const res = AGREEMENT_OPTIONS;
  return res;
}
export async function getFileCategories() {
  const res = FILECATEGORY;
  return res;
}
export async function getCountryCodes() {
  const res = COUNTRYCODE;
  return res;
}
export async function getLanguageCodes() {
  // const res = await SwesumClient.get(`/option?category=languagecode`);
  const res = LANGUAGECODE;
  return res;
}
export async function getCurrencyCodes() {
  // const res = await SwesumClient.get(`/option?category=currencycode`);
  const res = CURRENCYCODE;
  return res;
}
export async function getUserTypes() {
  // const res = await SwesumClient.get(`/option?category=usertype`);
  const res = USERTYPE;
  return res;
}
export async function getServices() {
  // const res = await SwesumClient.get(`/option?category=service`);
  const res = DEFAULT_SERVICE;
  return res;
}

// <===============  USER   =============>
export async function getUsers() {
  const res = await SwesumClient.get("/identity/appuser");
  return res.data;
}

export async function getUser(userID) {
  const res = await SwesumClient.get(`/identity/appuser/ ${userID}`);
  return res.data;
}

export async function createUser(data) {
  const res = await SwesumClient.post("/identity/create", data);
  return res;
}

export async function updateUser(userID, data) {
  const res = await SwesumClient.post(`/identity/update/${userID}`, data);
  return res;
}

export async function deleteUser(userID) {
  const res = await SwesumClient.post(`${baseURL}/identity/delete/${userID}`);
  return res;
}

// <===============  Client   =============>
export async function getClients() {
  const res = await SwesumClient.get("/client?template=0");
  return res.data;
}

export async function getShortInfoClients() {
  const res = await SwesumClient.get("/client/shortinfo");
  return res.data;
}

export async function getCompanySettings() {
  const res = await SwesumClient.get("/client?template=1");
  return res.data;
}

export async function getExtraClientInfo(clientID) {
  const res = await Promise.all([
    SwesumClient.get(`/clientpayments/clientpayment/client/${clientID}`),
    SwesumClient.get(`/system/log/client/${clientID}`),
    SwesumClient.get(`/identity/appuser`),
    SwesumClient.get(`/client/getalltermstemplates`),
    SwesumClient.get(`/client/getallagreementtemplates`),
  ]);
  const data = res.map((res) => res.data);
  return data;
}

export async function getAllAgreementTemplates() {
  const res = await SwesumClient.get(`/client/getallagreementtemplates`);
  return res.data;
}

export async function getAboutClient(clientID) {
  const res = await SwesumClient.post(`/workflow/client/info/${clientID}`);
  return res.data;
}

export async function getClient(clientID) {
  const res = await SwesumClient.get(`/client/${clientID}`);
  return res.data;
}

export async function createClient(body) {
  const res = await SwesumClient.post("/client/create", body);
  return res;
}

export async function updateClient(clientID, body) {
  const res = await SwesumClient.post(`/client/update/${clientID}`, body);
  return res;
}
export async function deleteClient(clientID) {
  const res = await SwesumClient.post(`/client/delete/${clientID}`);
  return res;
}

export async function createLogClient(body) {
  const res = await SwesumClient.post("/system/log/client/create", body);
  return res;
}

export async function getClientBalanceSummary() {
  const res = await SwesumClient.get("/client/balance/summary");
  return res.data;
}

// <===============  Endcustomer   =============>

export async function getEndcustomerInfoV2(endcustomerID) {
  const res = await Promise.all([
    SwesumClient.get(`/identity/appuser`),
    SwesumClient.get(`/system/log/endcustomer/${endcustomerID}`),
  ]);

  const data = res.map((res) => res.data);

  return data;
}

export async function createLogEndcustomer(body) {
  const res = await SwesumClient.post("/system/log/endcustomer/create", body);
  return res;
}

export async function getEndCustomers() {
  const res = await SwesumClient.get("/endcustomer");
  return res.data;
}

export async function getEndCustomerByEndCustomerID(endCustomerID) {
  const res = await SwesumClient.get(`/endcustomer/${endCustomerID}`);
  return res.data;
}

export async function getEndCustomersByClientId(clientID) {
  const res = await SwesumClient.get(`/endcustomer/client/${clientID}`);
  return res.data;
}

export async function updateEndCustomer(customerID, data) {
  const res = await SwesumClient.post(
    `/endcustomer/update/${customerID}`,
    data
  );
  return res;
}

export async function deleteEndcustomer(customerID) {
  const res = await SwesumClient.post(`/endcustomer/delete/${customerID}`);
  return res;
}

export async function createEndCustomer(body) {
  const res = await SwesumClient.post(`/endcustomer/create`, body);
  return res;
}

export async function getEndcustomerFormOptions() {
  const res = await Promise.all([
    SwesumClient.get(`/client`),
    getCountryCodes(),
    getAgreementOptionsHC(),
    getBoolOptionsHC(),
  ]);
  const data = res.map((res) => res.data);
  return data;
}

export async function getEndcustomerEvents(endCustomerId, body) {
  const res = await SwesumClient.post(
    `/endcustomer/events/${endCustomerId}`,
    body
  );
  return res.data;
}

// <===============  Invoices   =============>
export async function getAllInvoices() {
  const res = await SwesumClient.get(`/invoice`);
  return res.data;
}

export async function getInvoiceByInvoiceID(invoiceID) {
  const res = await SwesumClient.get(`/invoice/${invoiceID}`);
  return res.data;
}

export async function getCollectionInvoices() {
  const res = await SwesumClient.get("/invoice/collection");
  return res.data;
}

export async function updateInvoice(invoiceID, body) {
  const res = await SwesumClient.post(`/invoice/update/${invoiceID}`, body);
  return res;
}

export async function deleteInvoice(invoiceID) {
  const res = await SwesumClient.post(`${baseURL}/invoice/delete/${invoiceID}`);
  return res;
}

export async function createInvoice(body) {
  const res = await SwesumClient.post(`/invoice/create`, body);
  return res;
}

export async function getInvoicesByEndcustomerIdV2(endcustomerid, options) {
  if (!options) {
    options = {};
  }
  const res = await SwesumClient.post(
    `/invoice/v2/endcustomer/${endcustomerid}`,
    options
  );
  return res.data;
}

export async function getInvoicesByClientId(clientID, options) {
  if (!options) {
    options = {};
  }
  const res = await SwesumClient.post(
    `/invoice/v2/client/${clientID}`,
    options
  );
  return res.data;
}

export async function getSettlementBundlesByClientId(clientID) {
  const res = await SwesumClient.get(
    `/invoice/client/${clientID}/settlementbundles`
  );
  return res.data;
}

export async function getInvoicesGroupedByClientId() {
  const res = await SwesumClient.get(`/invoice/client`);
  return res.data;
}

export async function getInvoiceSummary() {
  const res = await SwesumClient.get("/invoice/summary");
  return res.data;
}

export async function checkInvoiceNumberExists(invoiceNumber, clientId) {
  const res = await SwesumClient.get(
    `/invoice/${invoiceNumber}/exists/${clientId}`
  );
  return res.data;
}

export async function searchInvoices(searchTerm, isExactSearch = false) {
  const res = await SwesumClient.get(
    `/invoice/search?reference=${searchTerm}${
      isExactSearch ? "&exactmatch=true" : ""
    }`
  );
  return res.data;
}

export async function getInvoiceFormOptions(clientId) {
  const res = await Promise.all([
    clientId
      ? SwesumClient.get(`/endcustomer/client/${clientId}`)
      : SwesumClient.get(`/endcustomer`),
    getCurrencyCodes(),
    getServices(),
    getBoolOptionsHC(),
  ]);
  const data = res.map((res) => res.data);
  return data;
}

export async function directPayment(invoiceId, body) {
  const res = await SwesumClient.post(
    `/invoice/${invoiceId}/directpayment`,
    body
  );
  return res;
}

export async function writeOff(invoiceId, body) {
  return await SwesumClient.post(`/invoice/${invoiceId}/writeoff`, body);
}

export async function writeOffAccount(accountId, body) {
  return await SwesumClient.post(`/invoice/${accountId}/writeoffaccount`, body);
}

export async function updateNextEvent(invoiceId, body) {
  const res = await SwesumClient.post(`/invoice/${invoiceId}/nextevent`, body);
  return res;
}

export async function changeFfd(invoiceId, body) {
  const res = await SwesumClient.post(`/invoice/${invoiceId}/changeffd`, body);
  return res;
}

export async function setInterestStopDate(invoiceId, date) {
  return await SwesumClient.post(`/invoice/${invoiceId}/intereststop`, {
    date: date,
  });
}

export async function changeStatus(invoiceId, body) {
  const res = await SwesumClient.post(
    `/invoice/${invoiceId}/changestatus`,
    body
  );
  return res;
}

export async function manualRegress(invoiceId) {
  const res = await SwesumClient.post(`/invoice/${invoiceId}/regress`);
  return res;
}

export async function createLogInvoice(body) {
  const res = await SwesumClient.post("/system/log/invoice/create", body);
  return res;
}

export async function getTotaltFinansierat(date) {
  return await SwesumClient.post(`/invoice/finansierat?date=${date}`);
}

// <===============  InterestInvoices   =============>
export async function getAllInterestInvoices() {
  const res = await SwesumClient.get("/account/endcustomer/interest");
  return res;
}

export async function activateInterestInvoice(body) {
  const res = await SwesumClient.post("/workflow/interestactive", body);
  return res;
}

export async function deleteInterestInvoice(body) {
  const res = await SwesumClient.post("/workflow/interestdeleted", body);
  return res;
}

// <===============  Reminders   =============>
export async function getReminders() {
  return await SwesumClient.get("/account/endcustomer/reminder");
}

export async function activateReminders(body) {
  return await SwesumClient.post("/workflow/reminderactive", body);
}

export async function deleteReminders(body) {
  return await SwesumClient.post("/workflow/reminderdeleted", body);
}

// <===============  Accounts   =============>

export async function getAllClientAccounts() {
  const res = await SwesumClient.get(`/account/client`);
  return res.data;
}

export async function getClientAccountByClientAccountID(id) {
  const res = await SwesumClient.get(`/account/client/${id}`);
  return res.data;
}

export async function getAccountsByClientID(clientId, options = {}) {
  const res = await SwesumClient.post(
    `/account/v2/client/clientid/${clientId}`,
    options
  );
  return res.data;
}

export async function getEndcustomerAccountsByClientID(clientId, options = {}) {
  const res = await SwesumClient.post(
    `/account/v2/endcustomer/clientid/${clientId}`,
    options
  );
  return res.data;
}

export async function getEndcustomerAccountsByEndcustomerId(
  endCustomerId,
  options = {}
) {
  const res = await SwesumClient.post(
    `/account/v2/endcustomer/endcustomer/${endCustomerId}`,
    options
  );
  return res.data;
}

export async function getClientAccountsByInvoiceID(invoiceID) {
  const res = await SwesumClient.get(`/account/client/invoice/${invoiceID}`);
  return res.data;
}

export async function createClientAccount(body) {
  const res = await SwesumClient.post(`/account/client/create`, body);
  return res;
}

export async function updateClientAccount(id, body) {
  const res = await SwesumClient.post(`/account/client/update/${id}`, body);
  return res;
}

export async function getAllEndcustomerAccounts() {
  const res = await SwesumClient.get(`/account/endcustomer`);
  return res.data;
}

export async function getEndcustomerAccountByEndcustomerAccountID(id) {
  const res = await SwesumClient.get(`/account/endcustomer/${id}`);
  return res.data;
}

export async function getEndcustomerAccountsByInvoiceID(invoiceID) {
  const res = await SwesumClient.get(
    `/account/endcustomer/invoice/${invoiceID}`
  );
  return res.data;
}

export async function createEndcustomerAccount(body) {
  const res = await SwesumClient.post(`/account/endcustomer/create`, body);
  return res;
}
export async function updateEndcustomerAccount(id, body) {
  const res = await SwesumClient.post(
    `/account/endcustomer/update/${id}`,
    body
  );
  return res;
}

export async function getUnplacedAccounts() {
  const res = await SwesumClient.get(`/account/endcustomer/oplac`);
  return res.data;
}

export async function getEndCustomerAccountReminders(body) {
  return await SwesumClient.post(
    `/workflow/endcustomeraccount/reminders`,
    body
  );
}

export async function getÖversiktInbetalningar(date) {
  return await SwesumClient.post(
    `/workflow/endcustomeraccount/inbetalningar?date=${date}`
  );
}

// <===============  EndCustomerAccountView   =============>

export async function searchEndCucstomerAccountView(
  searchTerm,
  fields = DEFAULT_SEARCH_FIELD_KEYS,
  signal
) {
  const params = new URLSearchParams();
  params.append("searchString", searchTerm);
  fields.forEach((field) => params.append("fields", field));

  const res = await SwesumClient.get(
    `/endcustomeraccountview/search?${params.toString()}`,
    { signal }
  );
  return res;
}

// <===============  Articles   =============>
export async function getAllClientArticles() {
  const res = await SwesumClient.get(`/article/client`);
  return res.data;
}
export async function getClientArticleByClientArticleID(id) {
  const res = await SwesumClient.get(`/article/client/${id}`);
  return res.data;
}

export async function getClientArticlePayRules() {
  const res = await SwesumClient.get(`/article/client/payrules`);
  return res.data;
}

export async function createClientArticle(body) {
  const res = await SwesumClient.post(`/article/client/create`, body);
  return res;
}

export async function updateClientArticle(id, body) {
  const res = await SwesumClient.post(`/article/client/update/${id}`, body);
  return res;
}

export async function getAllEndcustomerArticles() {
  const res = await SwesumClient.get(`/article/endcustomer`);
  return res.data;
}
export async function getEndcustomerArticleByEndcustomerArticleID(id) {
  const res = await SwesumClient.get(`/article/endcustomer/${id}`);
  return res.data;
}

export async function createEndcustomerArticle(body) {
  const res = await SwesumClient.post(`/article/endcustomer/create`, body);
  return res;
}

export async function updateEndcustomerArticle(id, body) {
  const res = await SwesumClient.post(
    `/article/endcustomer/update/${id}`,
    body
  );
  return res;
}

export async function getEndcustomerArticlePayRules() {
  const res = await SwesumClient.get(`/article/endcustomer/payrules`);
  return res.data;
}

export async function getEndcustomerArticlePayTypes() {
  const res = await SwesumClient.get(`/article/endcustomer/paytypes`);
  return res.data;
}

// <===============  Options   =============>

export async function getOption() {
  const res = await SwesumClient.get("/option");
  return res.data;
}

export async function createOption(body) {
  const res = await SwesumClient.post(`/option/create`, body);
  return res;
}

export async function getCategories(body) {
  const res = await SwesumClient.get(`/option/categories`, body);
  return res.data;
}

export async function getPaymentMethods() {
  const res = await SwesumClient.get(`/option?category=paymentmethod`);
  return res.data;
}

export async function getSystemStatusOption() {
  const res = await SwesumClient.get(`/option?category=systemstatus`);
  return res.data;
}

export async function getBoolOptions() {
  const res = await SwesumClient.get(`/option?category=boolvalue`);
  return res.data;
}

export async function getAgreementOptions() {
  const res = await SwesumClient.get(`/option?category=agreement`);
  return res.data;
}

export async function getOptionById(id) {
  const res = await SwesumClient.get(`/option/${id}`);
  return res.data;
}
export async function postOptionById(id, body) {
  const res = await SwesumClient.post(`/option/update/${id}`, body);
  return res.data;
}

// <===============  LogController   =============>

export async function getAllLogs() {
  const res = await SwesumClient.get("/system/log");
  return res.data;
}

export async function getWorkflowLogs(fromDate, toDate) {
  return await SwesumClient.post("/system/log/workflow", {
    FromDate: fromDate,
    ToDate: toDate,
  });
}

export async function getWorkflowErrorLogs() {
  return await SwesumClient.get("/system/log/workflow/error");
}

export async function updateHandledStatus(id, body) {
  return await SwesumClient.post(`/system/log/${id}/handled`, body);
}

export async function getLogsByInvoiceId(invoiceId) {
  const res = await SwesumClient.get(`/system/log/invoice/${invoiceId}`);
  return res.data;
}

// <===============  Endcustomerpaid   =============>
export async function getEndCustomerPaid() {
  const res = await SwesumClient.get("/invoice/endcustomerpayed");
  return res.data;
}

export async function getEndCustomerPaidByID(endcustomerPaidInvoiceId) {
  const res = await SwesumClient.get(
    `/invoice/endcustomerpayed/${endcustomerPaidInvoiceId}`
  );
  return res.data;
}

export async function getEndcustomerPaidByInvoiceID(invoiceID) {
  const res = await SwesumClient.get(
    `/invoice/endcustomerpayed/invoice/${invoiceID}`
  );
  return res.data;
}

export async function updateEndCustomerPaid(endcustomerPaidInvoiceId, body) {
  const res = await SwesumClient.post(
    `/invoice/endcustomerpayed/update/${endcustomerPaidInvoiceId}`,
    body
  );
  return res;
}

export async function createEndCustomerPaid(body) {
  const res = await SwesumClient.post(`/invoice/endcustomerpayed/create`, body);
  return res;
}

export async function deleteEndCustomerPaid(invoiceID) {
  const res = await SwesumClient.post(
    `/invoice/endcustomerpayed/delete/${invoiceID}`
  );
  return res;
}

// <===============  EndcustomerpaidBundles   =============>

export async function getAllEndCustomerPaidBundles() {
  const res = await SwesumClient.get("endcustomerpaymentbundle");
  return res;
}

export async function getEndCustomerPaidBundle(id) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${id}/matchinvoice`
  );
  return res;
}

// <===============  Endcustomerprinted   =============>
export async function getEndCustomerPrinted() {
  const res = await SwesumClient.get("/invoice/endcustomerprinted");
  return res.data;
}

export async function getEndCustomerPrintedByID(invoiceID) {
  const res = await SwesumClient.get(
    `/invoice/endcustomerprinted/${invoiceID}`
  );
  return res.data;
}

export async function getEndCustomerPrintedByInvoiceID(invoiceID) {
  const res = await SwesumClient.get(
    `/invoice/endcustomerprinted/invoice/${invoiceID}`
  );
  return res.data;
}

export async function updateEndCustomerPrinted(invoiceID, body) {
  const res = await SwesumClient.post(
    `/invoice/endcustomerprinted/update/${invoiceID}`,
    body
  );
  return res;
}

export async function createEndCustomerPrinted(body) {
  const res = await SwesumClient.post(
    `/invoice/endcustomerprinted/create`,
    body
  );
  return res;
}

export async function deleteEndCustomerPrinted(invoiceID) {
  const res = await SwesumClient.post(
    `invoice/endcustomerprinted/delete/${invoiceID}`
  );
  return res;
}

export async function getDebugFiles(endCustomerPrintedInvoiceId) {
  const res = await SwesumFileClient.get(
    `invoice/endcustomerprinted/files/${endCustomerPrintedInvoiceId}`,
    {
      responseType: "arraybuffer",
    }
  );
  return res;
}

// <===============  ClientPayment   =============>
export async function getClientPayments() {
  const res = await SwesumClient.get("/clientpayments/clientpayment");
  return res.data;
}

export async function getClientPaymentsDraft() {
  const res = await SwesumClient.get("/clientpayments/clientpayment/export");
  return res.data;
}

export async function getClientPaymentByPaymentID(clientPaymentId) {
  const res = await SwesumClient.get(
    `/clientpayments/clientpayment/${clientPaymentId}`
  );
  return res.data;
}

export async function getClientPaymentByClientID(clientID) {
  const res = await SwesumClient.get(
    `/clientpayments/clientpayment/client/${clientID}`
  );
  return res.data;
}

export async function updateClientPayment(clientPaymentID, body) {
  const res = await SwesumClient.post(
    `/clientpayments/clientpayment/update/${clientPaymentID}`,
    body
  );
  return res;
}

export async function createClientPayment(body) {
  const res = await SwesumClient.post(
    `/clientpayments/clientpayment/create`,
    body
  );
  return res;
}

export async function deleteClientPayment(clientPaymentID) {
  const res = await SwesumClient.post(
    `/clientpayments/clientpayment/delete/${clientPaymentID}`
  );
  return res;
}

// <===============  Clientinvoicebundle   =============>
export async function getClientInvoiceBundle() {
  const res = await SwesumClient.get("/bundles/clientinvoicebundle");
  return res.data;
}

export async function getClientInvoiceBundleBybundleID(bundleID) {
  const res = await SwesumClient.get(
    `/bundles/clientinvoicebundle/${bundleID}`
  );
  return res.data;
}

export async function getClientInvoiceBundleByinvoiceID(invoiceID) {
  const res = await SwesumClient.get(
    `/bundles/clientinvoicebundle/invoice/${invoiceID}`
  );
  return res.data;
}

export async function updateClientInvoiceBundle(bundleID, body) {
  const res = await SwesumClient.post(
    `/bundles/clientinvoicebundle/update/${bundleID}`,
    body
  );
  return res;
}

export async function createClientInvoiceBundle(body) {
  const res = await SwesumClient.post(
    `/bundles/clientinvoicebundle/create`,
    body
  );
  return res;
}

export async function deleteClientInvoiceBundle(bundleID) {
  const res = await SwesumClient.post(
    `/bundles/clientinvoicebundle/delete/${bundleID}`
  );
  return res;
}

// <===============  Books  =============>
export async function getBooks(body = {}) {
  const res = await SwesumClient.post(`/books`, body);
  return res.data;
}

export async function getBooksByID(id) {
  const res = await SwesumClient.get(`/books/${id}`);
  return res.data;
}
export async function updateBooks(bookID, body) {
  const res = await SwesumClient.post(`/books/update/${bookID}`, body);
  return res;
}
export async function createBook(body) {
  const res = await SwesumClient.post(`/books/create`, body);
  return res;
}
export async function createBookBulk(body) {
  const res = await SwesumClient.post(`/books/create/bulk`, body);
  return res;
}

// <===============  Balances  =============>
export async function getBalances(body, clientId = null) {
  let url = `/balance`;
  if (clientId !== null) {
    url = `/balance?clientId=${clientId}`;
  }
  const res = await SwesumClient.post(url, body);
  return res.data;
}

export async function getBalanceById(id) {
  const res = await SwesumClient.get(`/balance/${id}`);
  return res.data;
}

export async function updateBalance(id, body) {
  const res = await SwesumClient.post(`/balance/update/${id}`, body);
  return res.data;
}

export async function createBalance(body) {
  const res = await SwesumClient.post(`/balance/create`, body);
  return res.data;
}

// <===============  AccountCharts  =============>
export async function getAccountCharts() {
  const res = await SwesumClient.get(`/accountchart`);
  return res.data;
}

export async function createAccountChart(body) {
  const res = await SwesumClient.post(`/accountchart/create`, body);
  return res;
}

export async function updateAccountChart(id, body) {
  const res = await SwesumClient.post(`/accountchart/update/${id}`, body);
  return res;
}

export async function getAccountChartById(id) {
  const res = await SwesumClient.get(`/accountchart/${id}`);
  return res.data;
}

// <===============  Files  =============>

export async function getFiles() {
  const res = await SwesumClient.get(`/files`);
  return res.data;
}

export async function getFileTypes() {
  const res = await SwesumClient.get(`/files/filetypes`);
  return res.data;
}

export async function getPaymentFilesToProcess() {
  const res = await SwesumClient.get(
    `/files/category/bankinbetalning?status=active`
  );
  return res.data;
}

export async function getFileCategory(category) {
  const res = await SwesumClient.get(`/files/category/${category}`);
  return res.data;
}

export async function getFileCategoryWithoutContent(category) {
  return await SwesumClient.get(`/files/category/${category}/summary`);
}

export async function getFile(fileID) {
  const res = await SwesumClient.get(`/files/${fileID}`);
  return res.data;
}

export async function updateFile(fileID, body) {
  const res = await SwesumClient.post(`/files/update/${fileID}`, body);
  return res;
}

export async function downloadFile(fileID, fileType, fileName) {
  const res = await SwesumFileClient.get(`/files/download/${fileID}`, {
    responseType: "blob",
  });

  return res;
}

// <===============  Reports   =============>

export async function emailReport(fileID) {
  const res = await SwesumFileClient.get(`/report/email/${fileID}`);
  return res;
}

export async function emailNotCompletedReports() {
  return await SwesumFileClient.get(`/report/email/sendreports`);
}

export async function emailNotCompletedReportsByClientId(clientId) {
  const res = await SwesumFileClient.get(
    `/report/email/sendreports/${clientId}`
  );
  return res;
}

export async function getReports(clientId) {
  const res = await SwesumClient.get(`/report/client/${clientId}`);
  return res.data;
}

export async function generateCollectionReports(clientId) {
  return await SwesumClient.post(`/report/collection/${clientId}`);
}

export async function generateAllCollectionReports() {
  const res = await SwesumClient.post(`/report/collection`);
  return res;
}

export async function generateEngagementReport(clientId, body) {
  return await SwesumClient.post(`/report/engagement/${clientId}`, body);
}

export async function generatePayoutReport(clientId, body) {
  return await SwesumClient.post(`/report/payout/${clientId}`, body);
}

export async function generateSettlementReport(clientId, body) {
  return await SwesumClient.post(`/report/settlement/${clientId}`, body);
}

// <===============  EndCustomerPaymentBundles  =============>
export async function getAllEndCustomerPaymentBundles() {
  const res = await SwesumClient.get(`/endcustomerpaymentbundle`);
  return res.data;
}

export async function getEndCustomerPaymentBundles(body) {
  const res = await SwesumClient.post(`/endcustomerpaymentbundle`, body);
  return res.data;
}

export async function getEndCustomerPaymentBundleById(id) {
  const res = await SwesumClient.get(`/endcustomerpaymentbundle/${id}`);
  return res.data;
}

export async function updateEndCustomerPaymentBundleById(id, body) {
  const res = await SwesumClient.post(
    `/endcustomerpaymentbundle/update/${id}`,
    body
  );
  return res.data;
}

export async function coinRounding(id) {
  return await SwesumClient.post(
    `/endcustomerpaymentbundle/${id}/coinrounding`
  );
}

export async function deleteEndCustomerPaymentBundle(id) {
  return await SwesumClient.post(`/endcustomerpaymentbundle/delete/${id}`);
}

// <===============  PDF   =============>

export async function downloadClientAccountsPdfByClientId(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/clientaccounts/client/${clientId}`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadEndCustomerAccountsPdfByClientId(
  options,
  clientId
) {
  const res = await SwesumClient.post(
    `/pdf/endcustomeraccounts/client/${clientId}`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadEndCustomersPdfByClientId(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/endcustomers/client/${clientId}`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientPaymentsPdfByClientId(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/clientpayments/client/${clientId}`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientInvoicesPdfByClientId(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/invoices/client/${clientId}`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientSettlement(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/client/${clientId}/settlement`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientCollectionPCOEM(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/client/${clientId}/collection/pcoem`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientInvoicePayments(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/client/${clientId}/invoicepayments`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

export async function downloadClientPayments(options, clientId) {
  const res = await SwesumClient.post(
    `/pdf/client/${clientId}/payments`,
    options,
    {
      responseType: "blob",
    }
  );

  return res;
}

// <===============  WORKFLOWS   =============>

export async function parse(entityType, entityID, body) {
  const res = await SwesumClient.post(
    `/workflow/${entityType}/parse/${entityID}`,
    body
  );
  return res;
}

// <===============  WFClient   =============>

export async function creditSpace(clientID) {
  const res = await SwesumClient.post(
    `/workflow/client/creditspace/${clientID}`
  );
  return res;
}

export async function sendToPayment() {
  const res = await SwesumClient.post(`/workflow/client/sendtopayment`);
  return res;
}

export async function requiresPayment() {
  const res = await SwesumClient.post(`/workflow/client/requirespayment`);
  return res;
}

export async function inheritFromTemplate(clientID) {
  const res = await SwesumClient.post(
    `/workflow/client/inheritfromtemplate/${clientID}`
  );
  return res;
}

export async function clientGetUccheck(clientId) {
  const res = await SwesumClient.post(`/workflow/client/uccheck/${clientId}`);
  return res;
}

export async function accountSum(clientID) {
  const res = await SwesumClient.post(
    `/workflow/client/accountsum/${clientID}`
  );
  return res;
}

export async function clientGetOrCreateByOrg(orgnr, body) {
  const res = await SwesumClient.post(
    `/workflow/client/getorcreatebyorg/${orgnr}`,
    body
  );
  return res;
}

export async function inheritFromTerms(clientID, templateId) {
  const res = await SwesumClient.post(
    `/workflow/client/inheritfromtemplate/${clientID}/${templateId}`
  );
  return res;
}

export async function getClientInfo(clientID) {
  const res = await SwesumClient.post(`/workflow/client/info/${clientID}`);
  return res;
}

export async function getReskontra(clientId, date) {
  return await SwesumClient.post(
    `/workflow/client/reskontra/${clientId}?date=${date}`
  );
}

export async function createMissingAccountPayment(clientID) {
  const res = await SwesumClient.post(
    `/workflow/client/createmissingaccountpayment/${clientID}`
  );
  return res;
}

// <===============  WFClientPayment   =============>

export async function createClientBankfilesWorkflow(body) {
  const res = await SwesumClient.post(
    `/workflow/clientaccount/clientbankfiles/createbankfile`,
    body
  );
  return res;
}

export async function createFileBankfilesWorkflow(body) {
  const res = await SwesumClient.post(
    `/workflow/clientaccount/clientbankfiles/createfile`,
    body
  );
  return res;
}

// <===============  WORKFLOW INVOICE   =============>

export async function updateInvoiceFfdate(body) {
  const res = await SwesumClient.post(`/workflow/invoice/moveffd`, body);
  return res;
}

export async function inheritFromClient(invoiceID) {
  const res = await SwesumClient.post(
    `/workflow/invoice/inheritfromclient/${invoiceID}`
  );
  return res;
}

export async function sendToPrint(invoiceID) {
  const res = await SwesumClient.post(
    `/workflow/invoice/sendtoprint/${invoiceID}`
  );
  return res;
}

export async function requiresPrint(invoiceID) {
  const res = await SwesumClient.post(
    `/workflow/invoice/requiresprint/${invoiceID}`
  );
  return res.data;
}

export async function createAllMissingReminders() {
  const res = await SwesumClient.post(
    `/workflow/invoice/createallmissingreminders`
  );
  return res;
}

export async function createMissingEndcustomerAccounts(invoiceId) {
  const res = await SwesumClient.post(
    `/workflow/invoice/createmissingendcustomeraccounts/${invoiceId}`
  );
  return res;
}

export async function confirmImport(invoiceIds) {
  const res = await SwesumClient.post(
    `/workflow/invoice/confirmimport`,
    invoiceIds
  );
  return res.data;
}

export async function ignoreWarnings(invoiceIds) {
  const res = await SwesumClient.post(
    `/workflow/invoice/ignorewarnings`,
    invoiceIds
  );
  return res.data;
}

export async function deleteReferences(invoiceIds) {
  const res = await SwesumClient.post(
    `/workflow/invoice/deletereferences`,
    invoiceIds
  );
  return res.data;
}

export async function abortImport(invoiceIds) {
  const res = await SwesumClient.post(
    `/workflow/invoice/abortimport`,
    invoiceIds
  );
  return res.data;
}

export async function changeAgreementChain(agreementId, invoiceIds) {
  let id = 2;
  switch (agreementId) {
    case "purchase":
      id = 0;
      break;
    case "service":
      id = 1;
    default:
      break;
  }

  const res = await SwesumClient.post(
    `/workflow/invoice/changeagreementchain?agreementId=${id}`,
    invoiceIds
  );
  return res.data;
}

export async function applyCreditToInvoice(creditId, invoiceId) {
  const body = {
    invoiceId: Number(invoiceId),
    creditId: Number(creditId),
  };
  const res = await SwesumClient.post(
    `/workflow/invoice/applycredittoinvoice`,
    body
  );
  return res.data;
}

// <===============  WF ENDCUSTOMER   =============>

export async function uccheck() {
  const res = await SwesumClient.post(`/workflow/endcustomer/uccheck`);
  return res;
}

export async function endcustomerInheritFromClient(endcustomerId) {
  const res = await SwesumClient.post(
    `/workflow/endcustomer/inheritfromclient/${endcustomerId}`
  );
  return res;
}

export async function endcustomerGetOrCreateByOrg(orgnr, body) {
  const res = await SwesumClient.post(
    `/workflow/endcustomer/getorcreatebyorg/${orgnr}`,
    body
  );
  return res;
}

export async function endcustomerGetUccheck(endcustomerId) {
  const res = await SwesumClient.post(
    // `/workflow/endcustomer/uccheck`
    `/workflow/endcustomer/uccheck/${endcustomerId}`
  );
  return res;
}
export async function endcustomerGetUcparse(endcustomerId) {
  const res = await SwesumClient.post(
    `/workflow/endcustomer/ucparse/${endcustomerId}`
    // `/workflow/endcustomer/ucparse`
  );
  return res;
}

export async function endcustomerAgreementChain(endcustomerId, agreementvalue) {
  const res = await SwesumClient.post(
    `/workflow/endcustomer/ChangeAgreementChain/${endcustomerId}/${agreementvalue}`
  );
  return res;
}

// <===============  WF ENDCUSTOMERACCOUNT   =============>

export async function endcustomeraccountConnectOID(
  oid,
  invoiceId = null,
  accountId = null,
  clientId = null,
  amount = 0,
  bookingDate
) {
  const res = await SwesumClient.post(
    `/workflow/endcustomeraccount/connectoid`,
    {
      Oid: oid,
      InvoiceId: invoiceId,
      AccountId: accountId,
      ClientId: clientId,
      Amount: amount,
      BookingDate: bookingDate,
    }
  );
  return res;
}

// <===============  WF PAYEDINVOICE   =============>

export async function matchPayedInvoicesAgainstInvoices() {
  const res = await SwesumClient.post(`/workflow/payedinvoice/matchinvoice`);
  return res;
}

export async function connectMatch(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchconnect`,
    body
  );
  return res;
}

export async function matchPaymentToInvoice(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchpaymenttoinvoice`,
    body
  );
  return res;
}

export async function confirmMatches(bundleId) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchconfirm`
  );
  return res;
}

export async function matchRemove(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchremove`,
    body
  );
  return res;
}

export async function regretAccount(endCustomerAccountId){
  const res = await SwesumClient.post(
    `/workflow/endcustomeraccount/rollback/${endCustomerAccountId}`
  )
  return res;
}

export async function matchArticle(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matcharticle`,
    body
  );
  return res;
}

export async function matchConnectTwoPayments(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchconnecttwopayments`,
    body
  );
  return res;
}

export async function getpayedinvoicesfiles() {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/getpayedinvoicesfiles`
  );
  return res;
}

export async function createfromallfilesBundle(bundleId) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/createfromallfiles`
  );
  return res;
}

export async function createfromallfiles() {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/createfromallfiles`
  );
  return res;
}

export async function matchSearch(paidInvoiceId, OCR) {
  const body = { PaidInvoiceId: paidInvoiceId, Ocr: OCR };
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/matchsearch`,
    body
  );
  return res;
}

export async function matchExtendedSearch(paymentId) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/matchextendedsearch?paymentId=${paymentId}`
  );
  return res;
}

export async function matchaccount(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchaccount`,
    body
  );
  return res;
}

export async function matchCreditToInvoice(bundleId, body) {
  const res = await SwesumClient.post(
    `/workflow/payedinvoice/bundle/${bundleId}/matchcredit2invoice`,
    body
  );
  return res;
}

export async function generatePaymentReports() {
  return await SwesumClient.get("workflow/payedinvoice/generatepaymentreports");
}

// <===============  WF CLIENTPAYMENT  =============>

export async function createMissingClientPayments() {
  const res = await SwesumClient.post(
    "/workflow/clientpayments/createmissingclientpayments"
  );

  return res;
}

export async function confirmClientPayments(body) {
  const res = await SwesumClient.post(
    "/workflow/clientpayments/confirmPayments",
    body
  );

  return res;
}

// <===============  WF CLIENTINVOICEBUNDLE   =============>

export async function getInvoiceBundleFiles() {
  const res = await SwesumClient.post(
    `/workflow/clientinvoicebundle/getinvoicebundlesfiles`
  );
  return res;
}

export async function createClientInvoiceBundleFromFile(fileID) {
  const res = await SwesumClient.post(
    `/workflow/clientinvoicebundle/createfromfiles/${fileID}`
  );
  return res;
}

export async function createAllMissingInvoices() {
  const res = await SwesumClient.post(
    `/workflow/clientinvoicebundle/createinvoicesfrominvoicebundles`
  );
  return res;
}

export async function clientInvoiceBundleCreateFromAllFiles() {
  const res = await SwesumClient.post(
    `/workflow/clientinvoicebundle/createfromallfiles`
  );
  return res;
}

export async function CreateInvoiceBundleFromFortnox() {
  return await SwesumClient.post(
    `/workflow/clientinvoicebundle/CreateInvoiceBundleFromFortnox`
  );
}

// <===============  WF Printedinvoice   =============>

export async function printedInvoiceFlow() {
  return await SwesumClient.get(`/workflow/printedinvoice/printedInvoiceFlow`);
}

export async function createAllMissingPrintedInvoices() {
  const res = await SwesumClient.post(
    `/workflow/printedinvoice/createmissingprintedinvoices`
  );
  return res;
}

export async function createAllMissingPrintedInvoicesFiles() {
  const res = await SwesumClient.post(
    `/workflow/printedinvoice/createmissingfiles`
  );
  return res;
}

export async function sendPrintedInvoiceFiles() {
  const res = await SwesumClient.get(`/workflow/printedinvoice/sendfiles`);
  return res;
}

export async function createPrintedInvoicePrintFile(accountId) {
  const res = await SwesumClient.post(
    `/workflow/printedinvoice/createprintfile/${accountId}`
  );
  return res;
}

export async function uploadFile(multiPartformData) {
  const res = await SwesumFileClient.post(`/files/upload/`, multiPartformData);
  return res;
}

// Returns the message the API sent with an error response, if there is one.
export function getUploadErrorMessage(error, fallback) {
  const data = error?.response?.data;

  if (typeof data === "string" && data.length > 0) {
    return data;
  }

  if (typeof data?.title === "string" && data.title.length > 0) {
    return data.title;
  }

  return fallback;
}

export async function createPrintFileInvoice(invoiceId, useEndCustomer) {
  const body = useEndCustomer;
  const res = await SwesumClient.post(
    `/workflow/printedinvoice/createprintfileinvoice/${invoiceId}`,
    body
  );
  return res;
}
// <===============  WF BOOKS   =============>

export async function createallbooksfromaccounts() {
  const res = await SwesumClient.post(
    `/workflow/book/createallbooksfromaccounts`
  );
  return res;
}
export async function createsiefiles(toDate) {
  return await SwesumClient.post(`/workflow/book/createsiefiles`, null, {
    params: { toDate },
  });
}

// <===============  WF DASHBOARD   =============>
export async function runallaccountwf() {
  const res = await SwesumFileClient.post(`/workflow/runallaccountwf`);
  return res;
}

export async function runallprintedinvoicewf() {
  const res = await SwesumFileClient.post(`/workflow/runallprintedinvoicewf`);
  return res;
}
export async function runallclientpaymentwf() {
  const res = await SwesumFileClient.post(`/workflow/runallclientpaymentwf`);
  return res;
}
export async function runallbookwf() {
  const res = await SwesumFileClient.post(`/workflow/runallbookwf`);
  return res;
}

export async function migrationadjustment() {
  return await SwesumFileClient.post(`/workflow/migrationadjustment`);
}

export async function migrationoid() {
  return await SwesumFileClient.post(`/workflow/migrationoid`);
}

export async function migrationdone() {
  return await SwesumFileClient.post(`/workflow/migrationdone`);
}

export async function runallpaidinvoicewf() {
  const res = await SwesumFileClient.post(`/workflow/runallpaidinvoicewf`);
  return res;
}

export async function runallinvoicebundlewf() {
  const res = await SwesumFileClient.post(`/workflow/runallinvoicebundlewf`);
  return res;
}

export async function sendToCollection(body) {
  const res = await SwesumClient.post(`/workflow/sendToCollection`, body);
  return res;
}

export async function collectionPayments() {
  return await SwesumClient.post("/workflow/collectionpayments");
}

export async function collectionToEmail() {
  return await SwesumClient.post("/workflow/collectiontoemail");
}

// <===============  LABEL   =============>

export async function getLabelsByClientId(clientId) {
  return await SwesumClient.get(`/label/client/${clientId}`);
}

export async function updateLabelsByClientId(clientId, body) {
  return await SwesumClient.post(`/label/client/${clientId}/update/list`, body);
}

// <===============  FORTNOX   =============>

export async function createInvoicePayment(clientId) {
  return await SwesumClient.get(`/fortnox/payment/${clientId}`);
}

export async function fortnoxSendToClient(clientId) {
  const res = await SwesumClient.get(`/fortnox/${clientId}`);
  return res;
}

export async function fortnoxUnauthorizeClient(clientId) {
  return await SwesumClient.get(`/fortnox/${clientId}/delete`);
}

export async function fortnoxVerifyGUID(guid) {
  try {
    const res = await SwesumClient.get(`/fortnox/verify/${guid}`);
    return res;
  } catch (e) {
    return e.response;
  }
}

export async function fortnoxPostAuthVerify(guid, body) {
  return await SwesumClient.post(`/fortnox/verify/${guid}`, body);
}

export async function fortnoxGetStatus(clientId) {
  return await SwesumClient.get(`/fortnox/${clientId}/status`);
}

export async function fortnoxGetTokenCreateTime(clientId) {
  return await SwesumClient.get(`/fortnox/${clientId}/token/createtime`);
}

export async function fortnoxUpdateLabels(clientId) {
  return await SwesumClient.post(`/fortnox/${clientId}/label/update`);
}

export async function fortnoxSetImportAll(clientId, importAll) {
  return await SwesumClient.post(`/fortnox/${clientId}/setimport`, importAll);
}

export async function fortnoxSetTokenCreateTime(clientId, createtime) {
  return await SwesumClient.post(
    `/fortnox/${clientId}/token/createtime`,
    createtime
  );
}

export async function fortnoxReportBack() {
  return await SwesumClient.get("/fortnox/invoicePayment");
}

// <=============== TESTING WORKFLOW   =============>
export async function resetDatabase() {
  const res = await SwesumClient.post(`/workflow/resetdatabase`);
  return res;
}
